// extracted by mini-css-extract-plugin
export default {"option":"styles_option__tM2I7","price":"styles_price__fOMkU"};